'use client';
var classes = {"root":"m_89ab340","navbar":"m_45252eee","aside":"m_9cdde9a","header":"m_3b16f56b","main":"m_8983817","footer":"m_3840c879","section":"m_6dcfc7c7"};

export { classes as default };
//# sourceMappingURL=AppShell.module.css.mjs.map
